import ValueHelper from "base/ValueHelper";
import AjaxLogTransport from "logging/AjaxLogTransport";
import BeaconLogTransport from "logging/BeaconLogTransport";

/**
 * @property {LogDataTransport} transport
 */
export default class Logger {
    /**
     * @param {string} message
     * @param {Object} data
     */
    static emergency(message, data = null) {
        return Logger.log("emergency", message, data);
    }

    /**
     * @param {string} message
     * @param {Object} data
     */
    static alert(message, data = null) {
        return Logger.log("alert", message, data);
    }

    /**
     * @param {string} message
     * @param {Object} data
     */
    static critical(message, data = null) {
        return Logger.log("critical", message, data);
    }

    /**
     * @param {string} message
     * @param {Object} data
     */
    static error(message, data = null) {
        return Logger.log("error", message, data);
    }

    /**
     * @param {string} message
     * @param {Object} data
     */
    static warning(message, data = null) {
        return Logger.log("warning", message, data);
    }

    /**
     * @param {string} message
     * @param {Object} data
     */
    static notice(message, data = null) {
        return Logger.log("notice", message, data);
    }

    /**
     * @param {string} message
     * @param {Object} data
     */
    static info(message, data = null) {
        return Logger.log("info", message, data);
    }

    /**
     * @param {string} message
     * @param {Object} data
     */
    static debug(message, data = null) {
        return Logger.log("debug", message, data);
    }

    /**
     * @private
     * @param {string} level
     * @param {string} message
     * @param {?Object} data
     */
    static log(level, message, data = null) {
        try {
            data = this.process_log_data(data);

            console.info("Client Log: [%s] %s %o", level, message, data);
            Logger.transport.sendLog({
                level,
                message,
                data,
                page: window.location.href,
                request_id: Logger.REQUEST_ID,
                date: Math.round((new Date()).getTime() / 1000),
            });
        } catch (e) {
            console.error("Couldn't submit client log", arguments, e);
        }
    }

    static init() {
        Logger.REQUEST_ID = ValueHelper.random_string(30);

        if ('function' === typeof navigator.sendBeacon) {
            Logger.transport = new BeaconLogTransport();
        } else {
            Logger.transport = new AjaxLogTransport();
        }

        window.onunhandledrejection = function (e) {
            Logger.warning("Unhandled promise rejection", e.reason);
        };

        window.onerror = function (msg, url, lineNo, columnNo, error) {
            Logger.warning("Uncaught error", {
                message: msg,
                trace: error.stack,
            });
        };

    }

    /**
     * @private
     * @param {?object} data
     * @return {?object}
     */
    static process_log_data(data = null) {
        if (data === null) {
            return null;
        }

        let clean = {};

        if (data instanceof Error) {
            return {
                message: data.message,
                stack: data.stack,
            };
        }

        Object.keys(data).forEach((key) => {
            let value = data[key];

            let blacklisted = 'undefined' !== typeof BLACKLISTED_DATA_KEYS_MAP[key];

            if (blacklisted || /password/i.test(key)) {
                value = "{removed}";
            } else {
                if ("object" === typeof value && !Array.isArray(value)) {
                    value = Logger.process_log_data(value);
                }
            }

            clean[key] = value;
        });

        return clean;
    }
}


window._Logger = Logger;
Logger.init();

const BLACKLISTED_DATA_KEYS = [
    'cvv',
    'cv2',
    'securitycode',
    'security-code',
    'security_code',
    'cardcvv',
    'cardnumber',
    'card-number',
    'card_number',
    'expirydate',
    'expiry-date',
    'expiry_date',
    'cardexpirydate',
    'cardexpirymonth',
    'cardexpiryyear',
    'csrf',
    'static_csrf',
    'cardtype',
    'cardholder',
    'startdate',
    'startdate_m',
    'expirydate_m',
    'startdate_y',
    'expirydate_y',
    'issuenumber',
    'password',
    're_password',
    'password_retype',
];

const BLACKLISTED_DATA_KEYS_MAP = {};
BLACKLISTED_DATA_KEYS.forEach((key) => {
    BLACKLISTED_DATA_KEYS_MAP[key] = true;
});
